import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { spaceChangeColors } from 'src/features/issues/constants/issue-state/space-change/space-change-colors';
import { spaceChangeFilterValues } from 'src/features/issues/constants/issue-state/space-change/space-change-filter-values';
import { spaceChangeTranslations } from 'src/features/issues/constants/issue-state/space-change/space-change-translations';
import { IssueState } from 'src/features/issues/types/issue-state';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { getSelectedFilters } from 'src/utils/filters/get-selected-filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const SpaceChangeFilterPopover = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation(['issues']);

  const filterGroup: FilterGroup<IssueState | string> = {
    id: 2,
    type: 'spaceChange',
    label: t('issues:common.spaceChangeRequested.title'),
    singleOption: true,
    filterOperator: 'custom',
    items: [
      {
        label: t(spaceChangeTranslations.true),
        value: spaceChangeFilterValues.true,
        color: spaceChangeColors.true,
      },
      {
        label: t(spaceChangeTranslations.false),
        value: spaceChangeFilterValues.false,
        color: spaceChangeColors.false,
      },
    ],
  };

  return (
    <FilterPopover
      title={filterGroup.label}
      withStatusBadge
      selected={getSelectedFilters(filters, filterGroup.type)}
      onChange={option => {
        toggleFilterItemSelection(
          filterGroup.type,
          option,
          filterGroup.singleOption,
          filters,
          handleChangeFilterValue,
          filterGroup.filterOperator,
        );
      }}
      options={filterGroup.items}
    />
  );
};
